import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeposits = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	x: 0,
	y: 0,
	viewBox: "0 0 17 17",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(.251 .25)",
		children: [
			/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
				d: "M8.2 11.4V.9",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}) }),
			/* @__PURE__ */ _jsx("path", {
				d: "m10.9 8.8-2.6 2.6-2.7-2.6",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
				d: "M13.4 3.1c2.9 2.9 2.9 7.5 0 10.4s-7.5 2.9-10.4 0S.1 6 3 3.1c0 0 0 0 0 0",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}) })
		]
	})
});
export { SvgDeposits as ReactComponent };
